import React, { Component } from 'react';
import { Form, InputNumber, Modal } from 'antd';

class Demo extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleSet(values);
      }
    });
  };

  checkPrice = (rule, value, callback) => {
    if (value.number > 0) {
      callback();
      return;
    }
    callback('Price must greater than zero!');
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        visible
        title="单价设置"
        onCancel={this.props.onCancel}
        width={300}
        onOk={this.handleSubmit}
      >
        <Form>
          <Form.Item label="设置单价">
            {getFieldDecorator('unit', {})(<InputNumber precision={2} />)}
            <span style={{ paddingLeft: '5px' }}>元</span>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Demo);



// WEBPACK FOOTER //
// ./src/components/incubator/seat/SeatUnit.js